__turbopack_context__.v({
  "container": "BasicWrapper-module-scss-module__lcLVQa__container",
  "root": "BasicWrapper-module-scss-module__lcLVQa__root",
});
